import React, { useRef, useEffect } from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const InterventionsSection = ({
  sessionFormData,
  updateFormData,
  interventionsError,
  setInterventionsError,
  autoResizeTextarea,
  onAutoSave
}) => {
  const autoSaveTimeoutRef = useRef(null);

  const handleBlur = () => {
    // Clear any pending auto-save from onChange
    if (autoSaveTimeoutRef.current) {
      clearTimeout(autoSaveTimeoutRef.current);
      autoSaveTimeoutRef.current = null;
    }
    // Trigger auto-save immediately on blur
    if (onAutoSave) {
      onAutoSave();
    }
  };

  useEffect(() => {
    // Cleanup timeout on unmount
    return () => {
      if (autoSaveTimeoutRef.current) {
        clearTimeout(autoSaveTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Card id="interventions" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Interventions
      </h3>

      <div style={{ marginBottom: "24px" }}>
        <label className={styles.labelWithMargin}>
          Describe the interventions used
        </label>
        <textarea
          value={sessionFormData.interventionsUsed || ""}
          onChange={(e) => {
            const value = e.target.value;
            updateFormData("interventionsUsed", value);
            if (interventionsError && value.trim()) {
              setInterventionsError("");
            }
            // Debounced auto-save on change (1 second delay)
            if (autoSaveTimeoutRef.current) {
              clearTimeout(autoSaveTimeoutRef.current);
            }
            if (onAutoSave) {
              autoSaveTimeoutRef.current = setTimeout(() => {
                onAutoSave();
                autoSaveTimeoutRef.current = null;
              }, 1000);
            }
          }}
          onBlur={handleBlur}
          placeholder="Free-text"
          className={styles.textarea}
          required
        />
        {interventionsError && (
          <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
            {interventionsError}
          </div>
        )}
      </div>
    </Card>
  );
};

export default InterventionsSection;

